import React, { useRef, useEffect, useState, useCallback } from "react";

// ═══════════════════════════════════════════════════════════════════════
// PrintCompositor v44 — No background image. Canvas = plaque face.
// Canvas draws dark background + constellation. CSS = frame + base.
// ═══════════════════════════════════════════════════════════════════════

var PW = 800, PH = 1100; // Canvas resolution (portrait plaque ratio)
var F = {serif:'Georgia,"Times New Roman",Palatino,serif',sans:'"Helvetica Neue",Arial,sans-serif'};
var ENGRAVE = "rgba(255,235,200,";
var ENGRAVE_BRIGHT = "rgba(255,245,220,";

function spaced(ctx,text,x,y,sp,al){
  var tw=0;for(var i=0;i<text.length;i++){tw+=ctx.measureText(text[i]).width;if(i<text.length-1)tw+=sp;}
  var sx=al==="center"?x-tw/2:al==="right"?x-tw:x;
  ctx.textAlign="left";ctx.textBaseline="middle";
  var cur=sx;for(var i=0;i<text.length;i++){ctx.fillText(text[i],cur,y);cur+=ctx.measureText(text[i]).width+sp;}
}

function drawPlaque(ctx, W, H, data) {
  var s = W/PW;

  // ── Dark background (the glass face) ──
  ctx.fillStyle = "#0a0a0c";
  ctx.fillRect(0, 0, W, H);

  // Subtle background stars
  var seed = 42;
  for (var i = 0; i < 80; i++) {
    seed = (seed * 16807) % 2147483647;
    var bx = (seed % W);
    seed = (seed * 16807) % 2147483647;
    var by = (seed % H);
    seed = (seed * 16807) % 2147483647;
    var br = ((seed % 100) / 100) * 1.2 + 0.3;
    seed = (seed * 16807) % 2147483647;
    var bo = ((seed % 100) / 100) * 0.15 + 0.03;
    ctx.beginPath();
    ctx.arc(bx, by, br * s, 0, Math.PI*2);
    ctx.fillStyle = "rgba(255,240,210," + bo + ")";
    ctx.fill();
  }

  if (!data || !data.stars) return;

  var starMap = {};
  data.stars.forEach(function(st){ starMap[st.id] = st; });

  // ── Connection lines ──
  ctx.lineCap = "round";
  data.connections.forEach(function(conn){
    var a=starMap[conn[0]], b=starMap[conn[1]];
    if(!a||!b) return;
    var dx=a.x-b.x, dy=a.y-b.y;
    var dist=Math.sqrt(dx*dx+dy*dy);
    var opacity=Math.max(0.20, 0.50 - dist*1.2);
    ctx.strokeStyle=ENGRAVE+opacity+")";
    ctx.lineWidth=1.0*s;
    ctx.beginPath();ctx.moveTo(a.x*W,a.y*H);ctx.lineTo(b.x*W,b.y*H);ctx.stroke();
  });

  // ── Stars ──
  data.stars.forEach(function(star){
    var sx=star.x*W, sy=star.y*H;
    var res=star.resonance||3;
    var sizeMul=0.6+res*0.15;

    // Glow
    var gr=(16+res*5)*s*sizeMul;
    var g=ctx.createRadialGradient(sx,sy,0,sx,sy,gr);
    g.addColorStop(0,ENGRAVE_BRIGHT+(0.3+res*0.08)+")");
    g.addColorStop(0.25,ENGRAVE+(0.12+res*0.03)+")");
    g.addColorStop(0.6,ENGRAVE+"0.03)");
    g.addColorStop(1,ENGRAVE+"0)");
    ctx.beginPath();ctx.arc(sx,sy,gr,0,Math.PI*2);ctx.fillStyle=g;ctx.fill();

    // Sparkle (resonance >= 3)
    if(res>=3){
      var len=(6+res*2)*s;
      ctx.strokeStyle=ENGRAVE_BRIGHT+(0.2+res*0.06)+")";
      ctx.lineWidth=0.5*s;
      ctx.beginPath();ctx.moveTo(sx,sy-len);ctx.lineTo(sx,sy+len);ctx.stroke();
      ctx.beginPath();ctx.moveTo(sx-len,sy);ctx.lineTo(sx+len,sy);ctx.stroke();
    }

    // Center dot
    var dotR=(1.5+res*0.5)*s;
    ctx.beginPath();ctx.arc(sx,sy,dotR,0,Math.PI*2);ctx.fillStyle=ENGRAVE_BRIGHT+"0.90)";ctx.fill();
  });

  // ── Labels ──
  data.stars.forEach(function(star){
    var sx=star.x*W, sy=star.y*H;
    var off=16*s;
    var text=star.label.toLowerCase();
    var res=star.resonance||3;
    var baseSz=12+res*1;
    var sz=Math.round(baseSz*s);
    if(text.length>12) sz=Math.round(sz*0.80);

    ctx.font="italic 300 "+sz+"px "+F.serif;
    ctx.fillStyle=ENGRAVE+(0.5+res*0.08)+")";
    ctx.textBaseline="middle";

    var lp=star.labelPos||"right";
    if(lp==="left"){ctx.textAlign="right";ctx.fillText(text,sx-off,sy);}
    else if(lp==="top"){ctx.textAlign="center";ctx.fillText(text,sx,sy-off);}
    else if(lp==="bottom"){ctx.textAlign="center";ctx.fillText(text,sx,sy+off+sz*0.3);}
    else{ctx.textAlign="left";ctx.fillText(text,sx+off,sy);}
  });

  // ── Name ──
  var nSz=Math.round(42*s);
  ctx.font="italic 300 "+nSz+"px "+F.serif;
  ctx.fillStyle=ENGRAVE_BRIGHT+"0.88)";
  spaced(ctx,data.personName||"",W/2,H*0.66,4*s,"center");

  // Rule
  ctx.strokeStyle=ENGRAVE+"0.18)";ctx.lineWidth=0.4*s;
  var rl=50*s;
  ctx.beginPath();ctx.moveTo(W/2-rl,H*0.66+nSz*0.5);ctx.lineTo(W/2+rl,H*0.66+nSz*0.5);ctx.stroke();

  // Headline
  if(data.headline){
    var hSz=Math.round(11*s);
    ctx.font="italic 300 "+hSz+"px "+F.serif;
    ctx.fillStyle=ENGRAVE+"0.35)";
    spaced(ctx,data.headline,W/2,H*0.66+nSz*0.5+14*s,1.2*s,"center");
  }

  // Clusters
  var cls=data.clusters||[];
  var clY=H*0.80;
  var clSp=W/(cls.length+1);
  cls.forEach(function(cl,i){
    var cx=clSp*(i+1);
    ctx.font="500 "+Math.round(9*s)+"px "+F.sans;
    ctx.fillStyle=ENGRAVE+"0.38)";
    spaced(ctx,cl.name,cx,clY,3*s,"center");
    if(cl.subtitle){
      ctx.font="300 "+Math.round(7*s)+"px "+F.sans;
      ctx.fillStyle=ENGRAVE+"0.22)";
      spaced(ctx,cl.subtitle,cx,clY+12*s,2*s,"center");
    }
  });
}

// ═══════════════════════════════════════════════════════════════════════
// COMPONENT
// ═══════════════════════════════════════════════════════════════════════

export default function PrintCompositor(props) {
  var data = props.data;
  var theme = props.theme || "dark";
  var canvasRef = useRef(null);
  var [downloading, setDownloading] = useState(false);
  var dk = theme === "dark";

  var draw = useCallback(function(){
    var canvas = canvasRef.current;
    if (!canvas || !data) return;
    var w = canvas.parentElement.clientWidth;
    var h = w * PH / PW;
    var dpr = window.devicePixelRatio || 1;
    canvas.width = w*dpr; canvas.height = h*dpr;
    canvas.style.width = w+"px"; canvas.style.height = h+"px";
    var ctx = canvas.getContext("2d");
    drawPlaque(ctx, w*dpr, h*dpr, data);
  }, [data]);

  useEffect(function(){ if(data) draw(); }, [data, draw]);
  useEffect(function(){
    var r = function(){ draw(); };
    window.addEventListener("resize", r);
    return function(){ window.removeEventListener("resize", r); };
  }, [draw]);

  var handleDownload = useCallback(function(){
    if (!data) return;
    setDownloading(true);
    var off = document.createElement("canvas");
    off.width = PW * 3; off.height = PH * 3; // 3x for print quality
    var ctx = off.getContext("2d");
    drawPlaque(ctx, off.width, off.height, data);
    off.toBlob(function(blob){
      var a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = (data.personName||"plaque").replace(/\s+/g,"_")+"_plaque.png";
      a.click(); URL.revokeObjectURL(a.href);
      setDownloading(false);
    }, "image/png");
  }, [data]);

  if (!data) return null;

  return React.createElement("div", {style:{display:"flex",flexDirection:"column",alignItems:"center",gap:18}},
    // Plaque with CSS frame
    React.createElement("div", {style:{width:"100%",maxWidth:360,display:"flex",flexDirection:"column",alignItems:"center"}},
      // Glass plaque
      React.createElement("div", {style:{position:"relative",width:"100%",borderRadius:8,overflow:"hidden",border:"1.5px solid rgba(255,235,180,0.20)",boxShadow:"0 0 30px rgba(255,225,160,0.12), 0 0 60px rgba(255,225,160,0.06), 0 20px 50px rgba(0,0,0,0.4)"}},
        React.createElement("div", {style:{lineHeight:0,position:"relative"}},
          React.createElement("canvas", {ref:canvasRef, style:{display:"block",width:"100%"}}),
          // Edge glows
          React.createElement("div", {style:{position:"absolute",top:0,left:0,right:0,height:2,background:"linear-gradient(90deg, transparent 10%, rgba(255,235,180,0.30) 50%, transparent 90%)",pointerEvents:"none"}}),
          React.createElement("div", {style:{position:"absolute",bottom:0,left:0,right:0,height:4,background:"linear-gradient(90deg, transparent 5%, rgba(255,230,170,0.40) 50%, transparent 95%)",pointerEvents:"none"}}),
          React.createElement("div", {style:{position:"absolute",top:0,bottom:0,left:0,width:2,background:"linear-gradient(180deg, transparent 10%, rgba(255,235,180,0.15) 50%, transparent 90%)",pointerEvents:"none"}}),
          React.createElement("div", {style:{position:"absolute",top:0,bottom:0,right:0,width:2,background:"linear-gradient(180deg, transparent 10%, rgba(255,235,180,0.15) 50%, transparent 90%)",pointerEvents:"none"}})
        )
      ),
      // Wooden LED base
      React.createElement("div", {style:{width:"60%",height:30,background:"linear-gradient(180deg, #C4A060 0%, #A8864A 40%, #8B6E38 100%)",borderRadius:"0 0 8px 8px",boxShadow:"0 0 35px rgba(255,215,140,0.20), 0 8px 20px rgba(0,0,0,0.4)",marginTop:-2,position:"relative"}},
        React.createElement("div", {style:{position:"absolute",top:3,left:"12%",right:"12%",height:2,background:"rgba(255,230,170,0.55)",borderRadius:1,boxShadow:"0 0 10px rgba(255,225,160,0.45)"}})
      ),
      // Surface glow
      dk && React.createElement("div", {style:{width:"70%",height:35,background:"linear-gradient(180deg, rgba(255,225,160,0.05) 0%, transparent 100%)",marginTop:2,borderRadius:"0 0 50% 50%"}})
    ),

    React.createElement("p", {style:{fontFamily:F.sans,fontSize:10,fontWeight:300,color:"rgba(200,204,208,0.30)",letterSpacing:3,margin:0}}, "8 \u00D7 10 IN \u00B7 LED ACRYLIC PLAQUE"),

    React.createElement("button", {
      onClick: handleDownload, disabled: downloading,
      style:{background:"transparent",border:"1px solid rgba(200,204,208,"+(downloading?"0.06)":"0.20)"),color:downloading?"rgba(200,204,208,0.20)":"#F0F2F5",padding:"12px 36px",borderRadius:4,fontSize:10,fontWeight:300,letterSpacing:4,textTransform:"uppercase",cursor:downloading?"wait":"pointer",fontFamily:F.sans}
    }, downloading ? "rendering\u2026" : "download print")
  );
}
